import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useDocuments } from 'contexts/documents'
import Modal, { useModal } from 'modals/dialog'
import Form from 'components/form/controller'
import CheckboxField from 'components/form/field/checkbox'
import Paragraph from 'components/typography/paragraph'
import Actions from 'components/form/actions'
import { Plain, ButtonSubmit } from 'components/button'

const ExtendAccess = ({ count, salt }) => {
    const { formatMessage } = useIntl()
    const { dismiss } = useModal()

    const [extendingAccess, setExtendingAccess] = useState(false)
    const { bulkExtendDocumentOwnership } = useDocuments()

    const bulkExtendOwnership = async () => {
        setExtendingAccess(true)
        const { ok } = await bulkExtendDocumentOwnership()
        setExtendingAccess(false)

        ok && dismiss()
    }

    return (
        <>
            <Modal.Header heading={formatMessage({
                id: 'action_extend_access',
                defaultMessage: 'Extend access'
            })} />
            <Form
                layout="vertical"
                onSubmit={bulkExtendOwnership}>
                {({ errors, trigger }) => (
                    <>
                        <Modal.Body>
                            <Paragraph>
                                <FormattedMessage
                                    id="documents_ownership_extend_summary_count"
                                    defaultMessage="{count, plural, =0 {} =1 {The access for 1 document will be extended to also include administrators with See and edit access in the organization. Access can also be updated on a per-document basis.} other {The access for {count} documents will be extended to also include administrators with See and edit access in the organization. Access can also be updated on a per-document basis.}}"
                                    values={{ count }} />
                            </Paragraph>
                            <CheckboxField
                                salt={salt}
                                label={formatMessage({
                                    id: 'prompt_acknowledge_proceed',
                                    defaultMessage: 'I understand and wish to proceed.'
                                })}
                                name="acknowledge"
                                field={{ required: true }} />
                        </Modal.Body>
                        <Modal.Footer>
                            <Actions>
                                <Plain
                                    onClick={dismiss}
                                    className="neutral">
                                    <FormattedMessage
                                        id="action_cancel"
                                        defaultMessage="Cancel" />
                                </Plain>
                                <ButtonSubmit
                                    disabled={!!Object.keys(errors).length}
                                    {...(extendingAccess ? { className: 'loading' } : null)}
                                    ref={trigger}>
                                    <FormattedMessage
                                        id="action_extend_access"
                                        defaultMessage="Extend access" />
                                </ButtonSubmit>
                            </Actions>
                        </Modal.Footer>
                    </>
                )}
            </Form>
        </>
    )
}

export default ExtendAccess